import {useState} from "react"

export default function useCopyToClipboard() {

    const [copiedText, setCopiedText] = useState(null)

    const copyToClipboard = async text => {

        if (!navigator?.clipboard) {

            setCopiedText(null)
            return false

        }

        try {

            await navigator.clipboard.writeText(text)
            setCopiedText(text)
            return true

        } catch (error) {

            setCopiedText(null)
            return false

        }
    }

    return [copyToClipboard, copiedText]
}